import { useState, type FormEvent } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Toast } from '../components/Toast';

export function Login(): JSX.Element {
  const { user, signIn } = useAuth();
  const loc = useLocation();
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (user) return <Navigate to="/" replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    const { error } = await signIn(email, pw);
    if (error) {
      setErr(error);
      setLoading(false);
    }
  }

  const toast = (loc.state as { toast?: 'logout' | 'reset' } | null)?.toast;

  return (
    <div className="ari-app">
      <div className="login-page">
        {toast === 'logout' && <Toast>Signed out · see you next week</Toast>}
        {toast === 'reset' && <Toast>Check your email for reset instructions</Toast>}
        <div className="login-card">
          <div className="login-brand">
            <span className="dot" />
            <span>Ariel Operations Reports</span>
          </div>
          <h1 className="login-h">Sign in</h1>
          <div className="login-sub">Internal access only. Accounts are provisioned by Admin.</div>
          <form className="login-form" onSubmit={submit}>
            <div>
              <label className="input-label">Work email</label>
              <input
                className="input"
                style={{ width: '100%' }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <div>
              <label className="input-label">Password</label>
              <input
                className="input"
                type="password"
                style={{ width: '100%' }}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                autoComplete="current-password"
              />
              {err && <div className="input-error">{err}</div>}
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? <><span className="spinner" />Signing in…</> : 'Sign in'}
            </button>
          </form>
          <div className="login-foot">
            <Link className="btn-link" to="/forgot-password" state={{ email }}>Forgot password?</Link>
            <span>support@ariel.com</span>
          </div>
        </div>
      </div>
    </div>
  );
}
